import { render, staticRenderFns } from "./ClassicExamTextEditor.vue?vue&type=template&id=224b0722&scoped=true&"
import script from "./ClassicExamTextEditor.vue?vue&type=script&lang=ts&"
export * from "./ClassicExamTextEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b0722",
  null
  
)

export default component.exports